import Progress from './Progress.vue';

export default Progress;



// WEBPACK FOOTER //
// ./src/pages/profile/views/progress/index.ts